// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SticksFormStepSection-module-stepCountLabel-aBEqa{font-weight:450}.SticksFormStepSection-module-title-BDRTo{margin-bottom:10px;color:#373a36}.SticksFormStepSection-module-contentWrapper-72CH\\+{display:flex;align-items:flex-start;gap:10px;flex-wrap:wrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepCountLabel": "SticksFormStepSection-module-stepCountLabel-aBEqa",
	"title": "SticksFormStepSection-module-title-BDRTo",
	"contentWrapper": "SticksFormStepSection-module-contentWrapper-72CH+"
};
export default ___CSS_LOADER_EXPORT___;
